import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Dispute from "../../components/product/Dispute";
import StarRating from "../../components/product/StarRating";
import ReviewOrderModal from "../../components/product/RatingModal";

const statusSteps = ["pending", "confirmed", "shipped", "delivered"];

const OrderView = ({ activeOrder, setActiveOrder, setDetailOrder, getOrders }) => {

	const [showDispute, setShowDispute] = useState(false);
	const [showReview, setShowReview] = useState(false);
	const [orderRating, setorderRating] = useState(activeOrder.orderRating);
	const [isNew, setIsNew] = useState(true);

	const handleOrderRating = (rating) => {
		setIsNew(orderRating === undefined)
		setShowReview(true)
		setorderRating(rating)
	}

	const navigate = useNavigate();

	return (
		<div className="popup-box d-flex flex-column justify-content-center align-items-center" >

			{/* ORDER DETAILS */}
				{activeOrder && (
					<div className="order-details bg-white rounded-3 mb-3" style={{ minWidth: '1000px', maxHeight: '90dvh', overflowY: 'auto'}}>

						<div className="d-flex w-100 justify-content-between">
							<h5>Order Details – {new Date(activeOrder?.createdAt).toDateString()}</h5>
							<button className="btn btn-sm px-3 text-center text-white" style={{ backgroundColor: '#7dba38' }}
								onClick={() => {
									setActiveOrder(null)
									setDetailOrder(false)
									getOrders()
								}}
							>
								Close
							</button>
						</div>


						{/* Status Progress */}
						<div>
							<h5 className="fw-bold my-3">Order Status</h5>
							<div className="mb-1 progress-track">
								{statusSteps.map((step, index) => (
									<div className="progress-step" key={step}>
										<div
											style={{ height: '9px' }}
											className={` ${statusSteps.indexOf(activeOrder.buyerOrderStatus) >= index ? "active" : ""}`}
										>
										</div>
									</div>
								))}
							</div>

							<div className="mb-5 d-flex justify-content-between">
								{statusSteps.map((step, index) => (
									<div className="progress-step" key={step}>
										<small className={`text-muted`}>{step.toUpperCase()}</small>
									</div>
								))}
							</div>
						</div>

						{/* Items */}
						<div className="px-2" style={{marginBottom: '30px'}}>
							<h5 className="fw-bold mb-3">Items</h5>

							{activeOrder.items.map((item, idx) => (
								<div key={idx} className="d-flex mb-2 align-items-center" style={{ cursor: "pointer" }}
									onClick={() => navigate(`/product/${item?.productId}`, { state: { item: item.productId } })}
								>
									<img
										src={item.image}
										alt={item.productName}
										className="order-item-img"
									/>

									<div className="flex-grow-1 ms-3">
										<div className="fw-semibold">{item.productName}</div>
										<small className="text-muted">
											Qty: {item.quantity} | Store: {activeOrder?.sellerOrders?.filter(seller =>  seller.sellerId === item.sellerId)[0]?.seller?.fname}
										</small>
									</div>

									<div className="text-end">
										<div className="fw-semibold">
											USD {item.price * item.quantity}
										</div>
										<small className="text-muted">
											USD {item.price} each
										</small>
									</div>
								</div>
							))}

							{/* Totals */}
							<div className="d-flex pt-3 justify-content-between fs-6">
								<strong>Total</strong>
								<strong>
									{activeOrder.currency.toUpperCase()} {activeOrder.totalAmount?.toFixed(2)}
								</strong>
							</div>
						</div>

						<div className="px-2 w-100 bg d-flex justify-content-between mb-3">

							{/* Customer */}
							<div>
								<h5 className="fw-bold">Order By:</h5>
								<div className="d-flex mt-2">
									<div className="d-flex flex-column" style={{ minWidth: 130 }}>
										<p className="text-muted">Name:</p>
										<p className="text-muted">Phone:</p>
										<p className="text-muted">Email:</p>
										<p className="text-muted">Address:</p>
										<p className="text-muted">City:</p>
										<p className="text-muted">Postal:</p>
										<p className="text-muted">Tracking ID:</p>
									</div>
									<div className="d-flex flex-column">
										<p className="text-muted">{activeOrder?.customer?.name} <span className="text-white">.</span></p>
										<p className="text-muted">{activeOrder?.customer?.phone} <span className="text-white">.</span></p>
										<p className="text-muted">{activeOrder?.customer?.email} <span className="text-white">.</span></p>
										<p className="text-muted">{activeOrder?.customer?.address} <span className="text-white">.</span></p>
										<p className="text-muted">{activeOrder?.customer?.city}, {activeOrder?.customer?.state} <span className="text-white">.</span></p>
										<p className="text-muted">{activeOrder?.customer?.zip} <span className="text-white">.</span></p>
										<p className="text-muted">{activeOrder?._id.toUpperCase()} <span className="text-white">.</span></p>
									</div>
								</div>
							</div>

							{activeOrder.buyerOrderStatus === "delivered" && activeOrder.paymentStatus === "paid" && (
							<div className="text-end">
								<div className="mb-5 d-flex flex-column align-items-end">
									<h6 className="mb-0">How would you rate this order?</h6>
									<StarRating value={orderRating || 0} onChange={(rating)=>{
										handleOrderRating(rating)
									}}/>
								</div>
								<button 
									className="btn btn-danger btn-sm"
									onClick={() => setShowDispute(true)}
								>
									Raise Dispute
								</button>
							</div>
							)}
						</div>

						<Dispute
							show={showDispute}
							onClose={() => {
								setShowDispute(false)
							}}
							orderId={activeOrder._id}
							items={activeOrder.items}
						/>

						<ReviewOrderModal
							show={showReview}
							onClose={() => {
								// getOrders()
								setShowReview(false)
							}}
							isNew={isNew}
							order={activeOrder}
							handleOrderRating={(rating)=>{handleOrderRating(rating)}}
							orderRating={orderRating}
						/>


					</div>
				)}

		</div>
	);
};

export default OrderView;